

import { Observable } from 'rxjs';
import { Parameter } from '../common/parameter';

import{lemMstDetails} from '../../interfaces/lab/lemMstDetails';



export interface lemMstParameter extends Parameter {
    SearchTerm: number;
    OrderBy: string;
  
}

export interface lemMst {

    id?: string;
    machineCode?:string;
    machineName:string;
    purpose: string; 
    tenantId: string;    
    branchId: string;
    defaultFlag? :string;
    isBidirectional?: boolean;
 
    parameters?: lemMstParameter[];
    links?: any;
}

export abstract class lemMstData {
  
  abstract list(url: string): Observable<lemMst[]>;
  abstract create(url: string,data: lemMst): Observable<any>;
  abstract update(url: string,data: lemMst): Observable<any>;
  abstract delete(url: string): Observable<any>;
}
